import { Document } from 'jsonapi-typescript';
import { Observable } from 'rxjs';
import { Deserializer } from 'jsonapi-serializer';
import { MetaNew } from '../interfaces/meta-new.interface';
import { NotificationReads } from '../interfaces/notification-reads.interface';

const deserializer = new Deserializer({
	keyForAttribute: 'snake_case',
	typeAsAttribute: true,
	Notification: {
		valueForRelationship: (relationship: any) => relationship.id,
	},
	User: {
		valueForRelationship: (relationship: any) => relationship.id,
	},
	transform: (record: any) => {
		if (record.notification !== undefined) {
			record.notificationId = record.notification;
			delete record.notification;
		}
		if (record.user !== undefined) {
			record.userId = record.user;
			delete record.user;
		}
		return record;
	},
} as any);

export function deserializeNotificationReads(
	notification: Document
): Observable<{ notificationReads: NotificationReads[]; meta: MetaNew }> {
	return new Observable<{ notificationReads: NotificationReads[]; meta: MetaNew }>((observer) => {
		deserializer.deserialize(notification, (err: Error, response: any) => {
			if (err) {
				observer.error(err);
			} else {
				const data: any[] = Array.isArray(response) ? response : [response];
				observer.next({ notificationReads: data, meta: (notification as any)?.meta });
				observer.complete();
			}
		});
	});
}
